import { MUTATIONS } from '@/store/namespaces';
import {
  ArticleGroup,
  RootState, ShowConfirm, ShowMessage, ShowOnceDialog, ShowReasonPrompt, UserInfo,
} from '@/store/types';
import { MutationTree } from 'vuex';
import { MessageNotificationDto } from '@/services/api-clients';

export const mutations: MutationTree<RootState> = {
  [MUTATIONS.SET_INITIALIZED](state: RootState, initialized: boolean) {
    state.initialized = initialized;
  },
  [MUTATIONS.SET_LOADING](state: RootState, loading: boolean) {
    state.loading = loading;
  },
  [MUTATIONS.SHOW_SNACKBAR_MESSAGE](state: RootState, payload: ShowMessage) {
    state.snackbar = {
      type: payload.type,
      content: payload.content,
    };
  },
  [MUTATIONS.SET_USER_INFO](state: RootState, payload: UserInfo) {
    state.userInfo = { ...payload };
  },
  [MUTATIONS.SHOW_CONFIRM](state: RootState, payload: ShowConfirm) {
    state.confirm = { ...payload, result: null, isOpen: true };
  },
  [MUTATIONS.FINISH_CONFIRM](state: RootState, payload: boolean) {
    state.confirm.result = payload;
    state.confirm.isOpen = false;
  },
  [MUTATIONS.SHOW_REASON_PROMPT](state: RootState, payload: ShowReasonPrompt) {
    state.reasonPrompt = { ...payload, result: null, isOpen: true };
  },
  [MUTATIONS.FINISH_REASON_PROMPT](state: RootState, payload: { saved: boolean; reason: string }) {
    state.reasonPrompt.result = payload;
    state.reasonPrompt.isOpen = false;
  },
  [MUTATIONS.SET_ARTICLE_GROUPS](state: RootState, groups: ArticleGroup[]) {
    state.articleGroups = groups;
  },
  [MUTATIONS.VISIT_VEHICLE_LOG](state: RootState, payload: boolean) {
    state.visitedHints.vehicleLog = payload;
  },
  [MUTATIONS.SHOW_ONCE_DIALOG](state: RootState, payload: ShowOnceDialog) {
    state.onceDialog = { ...payload, isOpen: true };
  },
  [MUTATIONS.HIDE_ONCE_DIALOG](state: RootState) {
    state.onceDialog.isOpen = false;
  },
  [MUTATIONS.SET_KSEF_ENABLED](state: RootState, enabled: boolean) {
    state.ksefEnabled = enabled;
  },
  [MUTATIONS.SET_OPEN_SUPPORT_TICKETS_COUNT](state: RootState, count: number) {
    state.openSupportTicketsCount = count;
  },
  [MUTATIONS.SET_MESSAGE_NOTIFICATIONS](state: RootState, items: MessageNotificationDto[]) {
    state.messageNotifications = items;
  },
  // A hub event can arrive for a record GetAll already returned (reconnect), so the id is the guard.
  [MUTATIONS.ADD_MESSAGE_NOTIFICATION](state: RootState, item: MessageNotificationDto) {
    if (state.messageNotifications.some((n) => n.id === item.id)) return;
    state.messageNotifications = [item, ...state.messageNotifications];
  },
  [MUTATIONS.SET_MESSAGE_NOTIFICATION_IS_READ](state: RootState, payload: { id: number; state: boolean }) {
    const item = state.messageNotifications.find((n) => n.id === payload.id);
    if (item) item.isReaded = payload.state;
  },
  [MUTATIONS.SET_ALL_MESSAGE_NOTIFICATIONS_READ](state: RootState) {
    state.messageNotifications.forEach((n) => { n.isReaded = true; });
  },
  [MUTATIONS.SET_NOTIFICATION_SOUND_ENABLED](state: RootState, enabled: boolean) {
    state.notificationSoundEnabled = enabled;
  },
  // A ticket id asks the chat dock to open that conversation; the dock clears it back to null.
  [MUTATIONS.REQUEST_SUPPORT_CHAT_POPUP](state: RootState, ticketId: number | null) {
    state.supportChatPopupRequest = ticketId;
  },
};
